"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldAutoCompleteCoreInputs = void 0;
const input_inputs_1 = require("../input/input.inputs");
class EmeraldAutoCompleteCoreInputs extends input_inputs_1.EmeraldInputCoreInputs {
    constructor() {
        super(...arguments);
        this.focusChangeTimeoutMs = 50;
        this.closeOnFocusOut = true;
        this.minChar = 0;
        this.items = [];
        this.noItemsFoundText = 'No items found';
    }
}
exports.EmeraldAutoCompleteCoreInputs = EmeraldAutoCompleteCoreInputs;
//# sourceMappingURL=autocomplete.inputs.js.map